import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth";
import userSettings from "./userSettings";
import customers from "./accounting/customers";
import invoices from "./accounting/invoices";
import recurringInvoices from "./accounting/recurringInvoices";
import creditNotes from "./accounting/creditNotes";
import invoiceLogo from "./accounting/invoiceLogo";
import invoiceItemHistory from "./accounting/invoiceItemHistory";
import stripe from "./stripe";
import subscription from "./subscription";
import plans from "./plans";
import statistics from "./statistics";
import bookings from "./bookings";
import employees from "./management/employees";
import services from "./management/services";
import roster from "./management/roster";
import shops from "./shops";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    userSettings,
    customers,
    invoices,
    recurringInvoices,
    creditNotes,
    invoiceLogo,
    invoiceItemHistory,
    stripe,
    subscription,
    plans,
    statistics,
    bookings,
    employees,
    services,
    roster,
    shops
  }
});
